
const state = function () {
  return {
    searchFields: {
      AGENCY_CODE:null,
      STUDENT_LAST_NAME:null,
      STUDENT_FIRST_NAME: null,
      'DRIVERS_LICENSE.DRIVERS_LICENSE':null,
      STUDENT_DOB: null,
      CLASS_START_DATE: null,
      'ADDRESSES.LK_STATE_ID': null,
      'SESSIONS.CLASS.COURSE.COURSE_ID':null,
      STUDENT_EMAIL:null
    },
    courses: [],
    loadingData: false,
    list: [],
    pagination: {},
    filtering: {},
    studentClassList: [],
    inApprovedClass: false,
    autoCompleteList: [],
    classStudentList: [],
    studentForm: {
      STUDENT_ID: null,
      STUDENT_FIRST_NAME: '',
      STUDENT_MIDDLE_NAME: '',
      STUDENT_LAST_NAME: '',
      STUDENT_SUFFIX: null,
      STUDENT_SSN_A: '',
      STUDENT_DOB: null,
      STUDENT_GENDER: null,
      STUDENT_EMAIL: '',
      STUDENT_PHONE: '',
      STUDENT_NOTES: '',
      LK_USER_STATUS_ID: null,
      ACTIVE_IND: false
    },
    driversLicenseForm: {
      DRIVERS_LICENSE: '',
      LK_STATE_ID: null
    },
    billingAddressForm: {
      ADDRESS_ID: null,
      ADDRESS_1: '',
      ADDRESS_2: '',
      CITY: '',
      LK_STATE_ID: null,
      ZIP_CODE: ''
    },
    shippingAddressForm: {
      sameAsBilling: false,
      ADDRESS_ID: null,
      ADDRESS_1: '',
      ADDRESS_2: '',
      CITY: '',
      LK_STATE_ID: null,
      ZIP_CODE: ''
    },
    studentModal: {
      open: false,
      selectedTab: 'general',
      mode: '',
    },
  }
}

export default {
  ...state()
}

export const initialState = state()
